import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
export enum ScrollDirection {
  leftToRight = "left-to-right",
  rightToLeft = "right-to-left"
}
@Component({
  standalone: true,
  selector: 'app-scrolling-text',
  imports: [CommonModule],
  templateUrl: './scrolling-text.component.html',
  styleUrls: ['./scrolling-text.component.scss'],
  animations: [
    trigger('scrollAnimation', [
      state('running', style({ transform: 'translateX(-50%)' })), // Move by 50% of the total width
      transition('* => running', animate('{{ speed }}s linear')), // Dynamic speed
      state('paused', style({ transform: 'translateX(0)' })), // Pause at the current position
    ])
  ]
})
export class ScrollingTextComponent {
  ScrollDirection = ScrollDirection;



  readonly banner = input<any>(null);
}

